module.exports = __webpack_public_path__ + "img/player-play_muzic.c3c1e6b2.svg";